<!-- Loading indicator -->
<div *ngIf="isLoading" class="text-center">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  <p>Loading event details...</p>
</div>

<!-- Error message -->
<div *ngIf="error" class="alert alert-danger">
  <strong>Error:</strong> {{ error }}
  <button class="btn btn-sm btn-secondary ml-2" (click)="loadEvent()">
    <i class="fa fa-refresh"></i> Retry
  </button>
</div>

<!-- Event details -->
<div *ngIf="!isLoading && !error && eventViewModel" class="container-fluid">
  <div class="row">
    <div class="span12">
      <h1 data-automation-name="eventView">
        <i class="fa fa-calendar"></i>
        Viewing Event ({{ eventViewModel.id }}) "{{ eventViewModel.ven_id }} - {{ eventViewModel.event_id }}"
      </h1>
    </div>
  </div>

  <!-- Basic Event Information -->
  <div class="row">
    <div class="span12">
      <div class="well">
        <h3><i class="fa fa-info-circle"></i> Basic Information</h3>
        <table class="table table-striped">
          <tbody>
          <tr>
            <td><strong>ID:</strong></td>
            <td>{{ eventViewModel.id }}</td>
            <td><strong>Event ID:</strong></td>
            <td>{{ eventViewModel.event_id }}</td>
          </tr>
          <tr>
            <td><strong>VEN ID:</strong></td>
            <td>{{ eventViewModel.ven_id }}</td>
            <td><strong>Action ID:</strong></td>
            <td>{{ eventViewModel.action_id || 'N/A' }}</td>
          </tr>
          <tr>
            <td><strong>Status:</strong></td>
            <td>
                <span class="badge"
                      [class.badge-success]="eventViewModel.status === 'active'"
                      [class.badge-warning]="eventViewModel.status === 'pending'"
                      [class.badge-danger]="eventViewModel.status === 'cancelled'">
                  {{ eventViewModel.status || 'N/A' }}
                </span>
            </td>
            <td><strong>Priority:</strong></td>
            <td>{{ eventViewModel.priority }}</td>
          </tr>
          <tr>
            <td><strong>Test Event:</strong></td>
            <td>
                <span class="badge" [class.badge-info]="eventViewModel.test" [class.badge-secondary]="!eventViewModel.test">
                  {{ eventViewModel.test ? 'Yes' : 'No' }}
                </span>
            </td>
            <td><strong>Accepted:</strong></td>
            <td>
                <span *ngIf="eventViewModel.accepted !== null && eventViewModel.accepted !== undefined"
                      class="badge"
                      [class.badge-success]="eventViewModel.accepted"
                      [class.badge-secondary]="!eventViewModel.accepted">
                  {{ eventViewModel.accepted ? 'Yes' : 'No' }}
                </span>
              <span *ngIf="eventViewModel.accepted === null || eventViewModel.accepted === undefined" class="text-muted">N/A</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Timing Information -->
  <div class="row">
    <div class="span12">
      <div class="well">
        <h3><i class="fa fa-clock-o"></i> Timing Information</h3>
        <table class="table table-striped">
          <tbody>
          <tr>
            <td><strong>Start Time:</strong></td>
            <td>{{ eventViewModel.dtstart }}</td>
            <td><strong>Duration:</strong></td>
            <td>{{ eventViewModel.duration }}</td>
          </tr>
          <tr>
            <td><strong>Tolerance:</strong></td>
            <td>{{ eventViewModel.tolerance }}</td>
            <td><strong>Notification Duration:</strong></td>
            <td>{{ eventViewModel.notification_duration || 'N/A' }}</td>
          </tr>
          <tr>
            <td><strong>Ramp Up Duration:</strong></td>
            <td>{{ eventViewModel.ramp_up_duration || 'N/A' }}</td>
            <td><strong>Recovery Duration:</strong></td>
            <td>{{ eventViewModel.recovery_duration || 'N/A' }}</td>
          </tr>
          <tr>
            <td><strong>Created At:</strong></td>
            <td colspan="3">{{ eventViewModel.created_datetime }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Modification Information -->
  <div class="row" *ngIf="eventViewModel.modification_number || eventViewModel.modification_datetime || eventViewModel.modification_reason">
    <div class="span12">
      <div class="well">
        <h3><i class="fa fa-edit"></i> Modification Information</h3>
        <table class="table table-striped">
          <tbody>
          <tr>
            <td><strong>Modification Number:</strong></td>
            <td>{{ eventViewModel.modification_number || 'N/A' }}</td>
            <td><strong>Modification Date:</strong></td>
            <td>{{ eventViewModel.modification_datetime || 'N/A' }}</td>
          </tr>
          <tr>
            <td><strong>Modification Reason:</strong></td>
            <td colspan="3">{{ eventViewModel.modification_reason || 'N/A' }}</td>
          </tr>
          <tr>
            <td><strong>Previous Action IDs:</strong></td>
            <td colspan="3">{{ eventViewModel.previous_action_ids?.join(', ') || 'None' }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Market Context - FIXED -->
  <div class="row" *ngIf="eventViewModel.market_context">
    <div class="span12">
      <div class="well">
        <h3><i class="fa fa-market"></i> Market Context</h3>
        <table class="table table-striped">
          <tbody>
          <tr>
            <td><strong>Market Context:</strong></td>
            <td>{{ eventViewModel.market_context.market_context }}</td>
          </tr>
          <tr>
            <td><strong>Program:</strong></td>
            <td>{{ eventViewModel.market_context.program || 'N/A' }}</td>
          </tr>
          <tr>
            <td><strong>Operator:</strong></td>
            <td>{{ eventViewModel.market_context.operator || 'N/A' }}</td>
          </tr>
          <tr>
            <td><strong>Action Type:</strong></td>
            <td>{{ eventViewModel.market_context.action_type || 'N/A' }}</td>
          </tr>
          <tr>
            <td><strong>Product:</strong></td>
            <td>{{ eventViewModel.market_context.product || 'N/A' }}</td>
          </tr>
          <tr>
            <td><strong>Label:</strong></td>
            <td>{{ eventViewModel.market_context.label || 'N/A' }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Groups, Resources, and Parties -->
  <div class="row">
    <!-- Groups -->
    <div class="span4">
      <div class="well">
        <h3><i class="fa fa-users"></i> Groups</h3>
        <div *ngIf="eventViewModel.groups && eventViewModel.groups.length > 0">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Group ID</th>
              <th>Division</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let group of eventViewModel.groups; trackBy: trackByGroupId">
              <td>{{ group.group_id }}</td>
              <td>{{ group.division }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!eventViewModel.groups || eventViewModel.groups.length === 0" class="text-muted">
          <i class="fa fa-info-circle"></i> No groups assigned
        </div>
      </div>
    </div>

    <!-- Resources -->
    <div class="span4">
      <div class="well">
        <h3><i class="fa fa-cog"></i> Resources</h3>
        <div *ngIf="eventViewModel.resources && eventViewModel.resources.length > 0">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Resource ID</th>
              <th>Program Unit</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let resource of eventViewModel.resources; trackBy: trackByResourceId">
              <td>{{ resource.resource_id }}</td>
              <td>{{ resource.program_unit }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!eventViewModel.resources || eventViewModel.resources.length === 0" class="text-muted">
          <i class="fa fa-info-circle"></i> No resources assigned
        </div>
      </div>
    </div>

    <!-- Parties -->
    <div class="span4">
      <div class="well">
        <h3><i class="fa fa-group"></i> Parties</h3>
        <div *ngIf="eventViewModel.parties && eventViewModel.parties.length > 0">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Party ID</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let party of eventViewModel.parties; trackBy: trackByPartyId">
              <td>{{ party.party_id }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!eventViewModel.parties || eventViewModel.parties.length === 0" class="text-muted">
          <i class="fa fa-info-circle"></i> No parties assigned
        </div>
      </div>
    </div>
  </div>

  <!-- Signals -->
  <div class="row" *ngIf="eventViewModel.signals && eventViewModel.signals.length > 0">
    <div class="span12">
      <div class="well">
        <h3><i class="fa fa-signal"></i> Signals</h3>
        <div *ngFor="let signal of eventViewModel.signals; trackBy: trackBySignalId" class="panel panel-default">
          <div class="panel-heading">
            <h4 class="panel-title">
              <i class="fa fa-bolt"></i> {{ signal.signal_name }}
              <small class="text-muted">({{ signal.signal_type }})</small>
            </h4>
          </div>
          <div class="panel-body">
            <table class="table">
              <tbody>
              <tr>
                <td><strong>Signal ID:</strong></td>
                <td>{{ signal.signal_id }}</td>
                <td><strong>Current Value:</strong></td>
                <td>{{ signal.current_value }}</td>
              </tr>
              </tbody>
            </table>

            <!-- Signal Intervals -->
            <div *ngIf="signal.interval && signal.interval.length > 0">
              <h5><i class="fa fa-clock-o"></i> Intervals</h5>
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>UID</th>
                  <th>Duration</th>
                  <th>Signal Value</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let interval of signal.interval; trackBy: trackByIntervalId">
                  <td>{{ interval.uid }}</td>
                  <td>{{ interval.duration }}</td>
                  <td>{{ interval.signal_value }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="!signal.interval || signal.interval.length === 0" class="text-muted">
              <i class="fa fa-info-circle"></i> No intervals defined
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- VEN Information -->
  <div class="row" *ngIf="eventViewModel.ven">
    <div class="span12">
      <div class="well">
        <h3><i class="fa fa-server"></i> VEN Details</h3>
        <table class="table table-striped">
          <tbody>
          <tr>
            <td><strong>VEN Name:</strong></td>
            <td>{{ eventViewModel.ven.name || 'N/A' }}</td>
            <td><strong>VEN ID:</strong></td>
            <td>{{ eventViewModel.ven.ven_id }}</td>
          </tr>
          <tr>
            <td><strong>Environment:</strong></td>
            <td>{{ eventViewModel.ven.environment || 'N/A' }}</td>
            <td><strong>Profile:</strong></td>
            <td>{{ eventViewModel.ven.profile || 'N/A' }}</td>
          </tr>
          <tr>
            <td><strong>Platform ID:</strong></td>
            <td>{{ eventViewModel.ven.platform_id || 'N/A' }}</td>
            <td><strong>Paused:</strong></td>
            <td>
                <span class="badge" [class.badge-warning]="eventViewModel.ven.paused" [class.badge-success]="!eventViewModel.ven.paused">
                  {{ eventViewModel.ven.paused ? 'Yes' : 'No' }}
                </span>
            </td>
          </tr>
          <tr *ngIf="eventViewModel.vtnComment">
            <td><strong>VTN Comment:</strong></td>
            <td colspan="3">{{ eventViewModel.vtnComment }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="row" style="margin-top: 20px;">
    <div class="span12">
      <div class="btn-group">
        <button class="btn btn-default" (click)="back()">
          <i class="fa fa-arrow-left"></i> Back to Events
        </button>
      </div>
    </div>
  </div>
</div>

<!-- No data message -->
<div *ngIf="!isLoading && !error && !eventViewModel" class="text-center">
  <div class="well">
    <div class="alert alert-warning">
      <i class="fa fa-exclamation-triangle"></i>
      Event not found or no data available.
    </div>
    <button class="btn btn-default" (click)="back()">
      <i class="fa fa-arrow-left"></i> Back to Events
    </button>
  </div>
</div>
